@if (!gs.isVersion2) {
  <div class="w-100 h-100 Container widget-layout">
    <loader-component></loader-component>
    <router-outlet></router-outlet>
  </div>
}

@if (gs.isVersion2) {
  <div class="main-widget-container">
    <app-v2-header [logoImg]="logoImg"></app-v2-header>
    @if (bannerImg || gs.specialMealImage) {
      <div class="row m-0 undernav-image">
        <img [src]="bannerImg" class="banner-image" onerror="this.src=''" alt="" (error)="gs.errorImageHandler($event)"/>
      </div>
    }
    @if (!bannerImg) {
      <div class="main-title-margin"></div>
    }
    <div class="main-widget-detail-section">
      <router-outlet></router-outlet>
      @if (widgetSettings.IsWidgetFooterEnabled) {
        <app-v2-footer></app-v2-footer>
      }
    </div>
  </div>
  @if (loader) {
    <div>
      <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="rgba(151,29,75,0.9)" type="ball-pulse"
        [fullScreen]="true">
        <p style="color: white"> {{'LoadingText' | translate }}... </p>
      </ngx-spinner>
    </div>
  }
}
